import { useQuery } from '@tanstack/react-query'
import { FormEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetForm(formId: string): {
  form: FormEntity | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => Promise<any>
} {
  const {
    data: form,
    isLoading,
    isError,
    refetch,
  } = useQuery([getFormQueryKey(formId)], async () => {
    return qoursesApi.survey.surveyControllerGetFormV1(formId, 'false')
  })

  return { form, isLoading, isError, refetch }
}

export const getFormQueryKey = (formId: string) => ['forms', formId]
